import { render, staticRenderFns } from "./reaction.vue?vue&type=template&id=dc83f5dc&"
import script from "./reaction.vue?vue&type=script&lang=js&"
export * from "./reaction.vue?vue&type=script&lang=js&"
import style0 from "./reaction.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports